export default __webpack_public_path__ + "static/media/KMatchingIcon.581d81cd.svg";